import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetResubmissionValueByNotificationIdQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type GetResubmissionValueByNotificationIdQuery = { notification?: Maybe<{ __typename?: 'Notification', id: string, resubmissionInterval: number }> };


export const GetResubmissionValueByNotificationIdDocument = gql`
    query getResubmissionValueByNotificationId($id: UUID!) {
  notification(id: $id) {
    id
    resubmissionInterval
  }
}
    `;

/**
 * __useGetResubmissionValueByNotificationIdQuery__
 *
 * To run a query within a React component, call `useGetResubmissionValueByNotificationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResubmissionValueByNotificationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResubmissionValueByNotificationIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResubmissionValueByNotificationIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetResubmissionValueByNotificationIdQuery, GetResubmissionValueByNotificationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetResubmissionValueByNotificationIdQuery, GetResubmissionValueByNotificationIdQueryVariables>(GetResubmissionValueByNotificationIdDocument, options);
      }
export function useGetResubmissionValueByNotificationIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetResubmissionValueByNotificationIdQuery, GetResubmissionValueByNotificationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetResubmissionValueByNotificationIdQuery, GetResubmissionValueByNotificationIdQueryVariables>(GetResubmissionValueByNotificationIdDocument, options);
        }
export type GetResubmissionValueByNotificationIdQueryHookResult = ReturnType<typeof useGetResubmissionValueByNotificationIdQuery>;
export type GetResubmissionValueByNotificationIdLazyQueryHookResult = ReturnType<typeof useGetResubmissionValueByNotificationIdLazyQuery>;
export type GetResubmissionValueByNotificationIdQueryResult = Apollo.QueryResult<GetResubmissionValueByNotificationIdQuery, GetResubmissionValueByNotificationIdQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
